export const attributeSelector = state => state.attribute;
